import {HttpClient} from '@angular/common/http';
import {Component} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {Observable, of} from 'rxjs';
import {catchError, switchMap} from 'rxjs/operators';
import {OrganizationType} from './organization-type.enum';

@Component({
    selector: 'app-organization-details',
    template: `
    <ng-container *ngIf="this.organization$ | async as response; else loading">
      <div class="container-fluid">
        <div class="row">
          <div class="col-auto">
            <div class="page-title-box">
              <h4 class="page-title">{{ response.display_name }}</h4>
            </div>
          </div>
        </div>
        <ul class="nav nav-tabs border-0">
          <li class="nav-item">
            <a class="nav-link user-select-none border-0"
               role="button"
               [class.active]="this.selectedTab == this.OrganizationFeatures.CONTACTS && response.contacts_route"
               [class.disabled]="!response.contacts_route"
               (click)="this.selectedTab = this.OrganizationFeatures.CONTACTS"
            >Contacts</a>
          </li>
          <li class="nav-item">
            <a class="nav-link user-select-none border-0"
               role="button"
               [class.active]="this.selectedTab == this.OrganizationFeatures.USERS && response.users_route"
               [class.disabled]="!response.users_route"
               (click)="this.selectedTab = this.OrganizationFeatures.USERS"
            >Users</a>
          </li>
        </ul>
        <div class="nav-content bg-white px-2">
          <app-organization-contacts [contactsRoute]="response.contacts_route" *ngIf="this.selectedTab == this.OrganizationFeatures.CONTACTS && response.contacts_route"></app-organization-contacts>
        </div>
      </div>
    </ng-container>
    <ng-template #loading>
      <ng-container *ngIf="this.showError; else loadingContent">
        <div class="alert alert-danger m-3" role="alert">
          <h4 class="alert-heading">An error occurred while fetching organization details.</h4>
          <hr class="my-2">
          <p class="mb-0">If the error persists please contact us at <a class="text-danger" href="mailto:{{this.supportEmail}}">{{ this.supportEmail }}</a>.
          </p>
        </div>
      </ng-container>
      <ng-template #loadingContent>
        <app-loading-indicator [is_loading]="true"></app-loading-indicator>
      </ng-template>
    </ng-template>

  `,
    styles: ``,
    standalone: false
})
export class OrganizationDetailsComponent {
  // @ts-ignore
  private readonly ORGANIZATION_URL = `${Dmc.SUPPORT_API_ADDRESS}organizations`;
  protected readonly supportEmail = 'Support@DarkMatterIns.com';
  protected organization$: Observable<Organization>;
  protected showError = false;
  protected selectedTab = OrganizationFeatures.CONTACTS;
  protected OrganizationFeatures = OrganizationFeatures;

  constructor(private route: ActivatedRoute, private http: HttpClient) {
    this.organization$ = this.getOrganizationDetails();
  }

  private getOrganizationDetails(): Observable<Organization> {
    return this.getOrganizationId().pipe(
      switchMap(id => this.http.get<Organization>(`${this.ORGANIZATION_URL}/${id}`)),
      catchError(_ => {
        this.showError = true;
        return of(null);
      })
    );
  }

  private getOrganizationId(): Observable<string> {
    return this.route.paramMap.pipe(
      switchMap(params => of(params.get('organizationId')))
    );
  }
}

interface Organization {
  id: string;
  display_name: string;
  type: OrganizationType;
  is_active: boolean;
  updated_at: string;
  created_at: string;
  contacts_route?: string;
  users_route?: string;
}

enum OrganizationFeatures {
  CONTACTS,
  USERS
}
